<h2 *ngIf="authorized">{{ friendlyLOB[lob] }} Configuration</h2>
<h2 *ngIf="!authorized">You are not authorized to access that page.</h2>
<div fxLayout.xs="column" fxLayoutGap="10px" fxLayoutAlign="center">
  <button mat-raised-button color="primary"
    [routerLink]="[configRoute]"
    *ngIf="auth.hasPermission(configRole)">Wall Board Configuration</button>
  <button mat-raised-button color="primary"
    [routerLink]="[wallRoute]"
    *ngIf="auth.hasPermission(wallRole)">Wall Board</button>
</div>